import { Banner } from '@loadsmart/loadsmart-ui'
import { Layout, Text } from '@loadsmart/miranda-react'

import ImgCarrierOnboardingRMIS from 'legacy/assets/svg/carrier-onboarding-rmis.svg'
import { I18n } from 'legacy/components/I18n/i18n'

type RMISUnderReviewBannerProps = {
  compact?: boolean
}

function RMISUnderReviewBanner({ compact }: RMISUnderReviewBannerProps) {
  return compact ? (
    <Banner
      scale="default"
      variant="warning"
      title={I18n.get('lb.RMIS.onboardingBanner.underReview.title')}
    />
  ) : (
    <Layout.Box backgroundColor="color-neutral-0" padding="spacing-8">
      <Layout.Group gap="spacing-12">
        <img src={ImgCarrierOnboardingRMIS} alt="RMIS Onboarding" width="238px" height="189px" />
        <Layout.Stack justify="center">
          <Text variant="heading-lg-bold">
            {I18n.get('lb.RMIS.onboardingBanner.underReview.title')}
          </Text>
          <Text variant="body-md">
            {I18n.get('lb.RMIS.onboardingBanner.underReview.description')}
          </Text>
          <Text variant="body-md-bold">
            {I18n.get('lb.RMIS.onboardingBanner.underReview.disclaimer')}
          </Text>
        </Layout.Stack>
      </Layout.Group>
    </Layout.Box>
  )
}

export { RMISUnderReviewBanner }
